import AssessmentsList from "@/pages/AssessmentsList";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/assessments/")({
  component: AssessmentsList,
});
